// 全角文字チェック
export function isIncludedDoubleByteChar(str: string) {
  for (let i = 0; i < str.length; i++) {
    const char = str.charCodeAt(i);
    // Shift_JIS: 0x0 ～ 0x80, 0xa0 , 0xa1 ～ 0xdf , 0xfd ～ 0xff
    // Unicode : 0x0 ～ 0x80, 0xf8f0, 0xff61 ～ 0xff9f, 0xf8f1 ～ 0xf8f3
    if (
      (char >= 0x0 && char < 0x81) ||
      char == 0xf8f0 ||
      (char >= 0xff61 && char < 0xffa0) ||
      (char >= 0xf8f1 && char < 0xf8f4)
    ) {
      // 半角文字
    } else {
      // 全角文字
      return true;
    }
  }
  return false;
}

export const zeroPadding = (num: number, len: number) => (Array(len).join("0") + num).slice(-len);

export const maskPassword = (p: string): string =>
  (p &&
    Array.from(p)
      .map(() => "*")
      .join("")) ||
  "";

export const verifyEmail = (email: string, suffix?: boolean): string => {
  if (!email || email.trim() === "") return "メールアドレスが設定されてません";
  if (isIncludedDoubleByteChar(email)) {
    return "メールアドレスに全角文字を含めないでください";
  }
  const regexWithoutSuffix =
    /^(("[\w-\s]+")|([\w-]+(?:\.[\w-]+)*)|("[\w-\s]+")([\w-]+(?:\.[\w-]+)*))(@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,63}(?:\.[a-z]{2,63})?)$)|(@\[?((25[0-5]\.|2[0-4][0-9]\.|1[0-9]{2}\.|[0-9]{1,2}\.))((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\.){2}(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\]?$)/i;
  const regexWithSuffix =
    /^(("[\w-\s]+")|([\w-+]+(?:\.[\w-+]+)*)|("[\w-\s]+")([\w-+]+(?:\.[\w-+]+)*))(@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,63}(?:\.[a-z]{2,63})?)$)|(@\[?((25[0-5]\.|2[0-4][0-9]\.|1[0-9]{2}\.|[0-9]{1,2}\.))((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\.){2}(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\]?$)/i;
  if (!email.match(suffix ? regexWithSuffix : regexWithoutSuffix)) {
    return "メールアドレスのフォーマットが誤っています";
  }
  return "";
};

const PLACEHOLDER_EMAIL_REGEX = /^\d+-[a-f0-9]{8}@unit-g\.com$/;

export const isValidDeliveryEmail = (email: string | null | undefined): boolean => {
  if (!email) return false;
  if (verifyEmail(email) !== "") return false;
  return !PLACEHOLDER_EMAIL_REGEX.test(email);
};

// 半角英数字をそれぞれ1種類以上含む6文字以上100文字以下の正規表現
export const verifyPassword = (password: string): string => {
  if (!password || password.trim() === "") return "パスワードが設定されていません";
  if (isIncludedDoubleByteChar(password)) {
    return "パスワードに全角文字を含めないでください";
  }
  if (!password.match(/^(?=.*?[a-z])(?=.*?\d)[a-z\d]{6,100}$/i)) {
    return "パスワードは、6文字以上でかつ、半角英数字をそれぞれ1種類以上含めてください";
  }
  return "";
};

export const verifyPhoneNumber = (phoneNumber: string): string => {
  if (!phoneNumber || phoneNumber.trim() === "") return "電話番号が設定されていません";

  if (!phoneNumber.match(/^0\d{9,10}$/i)) {
    return "電話番号のフォーマットが誤っています";
  }

  return "";
};

export const verifyTextKana = (text: string, fieldName: string): string => {
  if (!text || text.trim() === "") return `${fieldName}が設定されていません`;

  if (!text.match(/^[\u30A0-\u30FF\u0020\u3000]+$/)) {
    return `${fieldName}は全角カタカナで入力してください`;
  }
  return "";
};

export const GOURMET_SITE_DOMAINS = [
  "tabelog.com",
  "gnavi.co.jp",
  "retty.me",
  "hitosara.com",
  "favy.jp",
  "ozmall.co.jp",
  "restaurant.ikyu.com",
  "savorjapan.com",
  "paypaygourmet.yahoo.co.jp",
] as const;

export const HOTPEPPER_DOMAINS = ["hotpepper.jp"] as const;

const normalizeHost = (value: string): string => {
  const trimmed = value.trim();
  const withScheme = /^[a-z][a-z\d+.-]*:\/\//i.test(trimmed) ? trimmed : `https://${trimmed}`;
  try {
    return new URL(withScheme).hostname.toLowerCase();
  } catch {
    return "";
  }
};

const isDomainOrSubdomain = (host: string, domain: string): boolean =>
  host === domain || host.endsWith(`.${domain}`);

export const getUrlType = (
  url: string | null | undefined,
): "hotpepper-reservation" | "tabelog-reservation" | "other-reservation" => {
  if (!url) return "other-reservation";
  const host = normalizeHost(url);
  if (HOTPEPPER_DOMAINS.some((d) => isDomainOrSubdomain(host, d))) return "hotpepper-reservation";
  if (GOURMET_SITE_DOMAINS.some((d) => isDomainOrSubdomain(host, d))) return "tabelog-reservation";
  return "other-reservation";
};

export const verifyUrl = (value: string): string => {
  if (!value || value.trim() === "") return "URLが設定されていません";

  const s = value.trim();
  if (s.match(/\s/)) return "URLに空白は使用できません";

  try {
    const u = new URL(s);
    if (u.protocol !== "http:" && u.protocol !== "https:") {
      return "URLのプロトコルは http または https を使用してください";
    }
    if (!u.hostname) return "URLのホスト名が無効です";
    return "";
  } catch {
    return "URLの形式が正しくありません";
  }
};

export const ellipsis = (str: string, size: number) => {
  if (!str) {
    return "";
  }
  let t = "";
  let s = size * 2;
  const e = "...";
  for (let i = 0; i < str.length; i++) {
    const _string = str.charAt(i);
    if (/[a-zA-Z0-9\s]/.test(_string)) {
      s -= 1;
    } else s -= 2;
    t = t + _string;
    if (s <= 0) {
      t += e;
      break;
    }
  }
  return t;
};

export const formatSnsTitle = (text: string) => {
  if (text === "all") return "すべて";
  if (text === "tiktok") return "TikTok";
  if (text === "youtube") return "YouTube";
  if (text === "instagram") return "Instagram";
  if (text === "instagram-pro") return "Instagram(プロアカウント)";
  if (text === "twitter") return "X(旧Twitter)";
  if (text === "google") return "Google";
  if (text === "tabelog") return "グルメサイト";
  if (text === "trip-adviser") return "TripAdviser（準備中）";
  if (text === "media") return "メディア関係者";
  return text;
};
export const verifySnsAccounts = (accountType: string, accountUrl: string): string => {
  if (!accountUrl) return "";
  const REGEX = /^(https?|ftp)(:\/\/[-_.!~*\'()a-zA-Z0-9;\/?:\@&=+\$,%#]+)$/;
  if (!accountUrl.match(REGEX)) {
    return "URLの形式が無効です";
  }
  if (accountType === "youtube") {
    if (!accountUrl.includes("youtu")) return `URLに${accountType}が含まれていません`;
    else return "";
  } else {
    if (!accountUrl.includes(accountType)) {
      return `URLに${accountType}が含まれていません`;
    }
  }
  return "";
};

/**
 * ファイル名を抽出して名前衝突回避の為にsuffixにUNIX_TIMEを挿入する
 * @param baseName
 * @param extension
 */
export const generateFileName = (baseName: string, extension: string = "") => {
  // 名前衝突を防ぐ為にunix_timeをファイル名に付与する
  const unix_time = new Date().getTime().toString();

  // パスからファイル名を抽出
  const fileName = baseName.split("/").pop() || baseName;
  // ファイル名から拡張子を分離
  const fileStems = fileName.split(".");

  // ファイル名に拡張子がついていなかった場合
  if (fileStems.length === 1) {
    return `${fileStems[0]}_${unix_time}.${extension}`;
  }

  const fileStem = fileStems.slice(0, -1).join(".");
  const ext = extension || fileStems.pop() || "";
  return `${fileStem}_${unix_time}.${ext}`;
};

// E.164 format for Firebase
export const formatPhoneNumberToFirebase = (input: string): string | null => {
  let digits = (input || "").replace(/\D/g, "");
  if (!digits) return null;

  if (digits.startsWith("81")) {
    digits = digits.slice(2);
  } else if (digits.startsWith("0081")) {
    digits = digits.slice(4);
  } else if (digits.startsWith("0")) {
    digits = digits.slice(1);
  } else {
    return null;
  }

  if (digits.startsWith("0")) {
    digits = digits.slice(1);
  }

  if (!/^\d{9,10}$/.test(digits)) return null;

  return `+81${digits}`;
};

/**
 * 住所の番地と建物名・部屋番号を表示用に連結する。
 * 「1-2-3」「101」が「1-2-3101」と読めないよう、前後の空白だけを除いて値のあるものを半角空白1つで区切る。
 * 値の内部の空白はそのまま残す（IFアプリ本体の表示と同じ規則）。
 */
export const joinStreetAndBuilding = (street?: string | null, building?: string | null): string =>
  [street, building]
    .map((value) => (value ?? "").trim())
    .filter(Boolean)
    .join(" ");
